import React from "react";
import { quotationReferencePreview, formatQuotationReference } from "../../lib/quotationHistory";
import { FullValuePopoverContent } from "../ui/data-presentation";
import { Popover, PopoverTrigger } from "../ui/popover";

export default function QuotationReferencesCell({ mode, references = [] }) {
  const { visible, hiddenCount } = quotationReferencePreview(references);
  if (!references.length) return <span className="text-muted-foreground">—</span>;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="block max-w-[300px] text-left text-xs leading-5 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label={`Show all ${references.length} quotation references`}
        >
          {visible.map((reference, index) => (
            <span className="block truncate" key={`${index}-${reference.serial_number}`}>
              {formatQuotationReference(reference, mode)};
              {index === 1 && hiddenCount > 0 ? (
                <span className="ml-1 font-semibold text-primary">+{hiddenCount}</span>
              ) : null}
            </span>
          ))}
        </button>
      </PopoverTrigger>
      <FullValuePopoverContent
        value={references}
        renderListItem={(reference) => formatQuotationReference(reference, mode)}
        ariaLabel={`All ${references.length} quotation references`}
      />
    </Popover>
  );
}
